import React from 'react';

import { BaseButton, ButtonGroup, PrimaryButton } from '@common/components';
import { Colors } from 'works/legacy/lib/style-helper';
import { WorkerTimesheetActions } from '@common/graphql/schema';

export const GroupButtons = ({
  loading,
  onAction,
  timesheet,
}: {
  loading: WorkerTimesheetActions | undefined;
  onAction: (action: WorkerTimesheetActions) => void;
  timesheet: {
    canApprove: { value: boolean };
    canReject: { value: boolean };
    canUnapprove: { value: boolean };
  };
}) => {
  return (
    <ButtonGroup>
      {timesheet.canReject.value && (
        <BaseButton
          type="ghost"
          className="worker-timesheet-reject-button"
          style={{ color: Colors.coral }}
          onClick={() => onAction('reject')}
          loading={loading === 'reject'}
          disabled={loading && loading !== 'reject'}
        >
          Reject
        </BaseButton>
      )}
      {timesheet.canApprove.value && (
        <PrimaryButton
          className="worker-timesheet-approve-button"
          onClick={() => onAction('approve')}
          loading={loading === 'approve'}
          disabled={loading && loading !== 'approve'}
        >
          Approve
        </PrimaryButton>
      )}
      {timesheet.canUnapprove.value && (
        <BaseButton
          className="worker-timesheet-unapprove-button"
          type="ghost"
          style={{ color: Colors.coral }}
          onClick={() => onAction('unapprove')}
          loading={loading === 'unapprove'}
          disabled={loading && loading !== 'unapprove'}
        >
          Unapprove
        </BaseButton>
      )}
    </ButtonGroup>
  );
};
